<template>
  <div>
    <!-- <audio ref="audioPlayer" src="notify.mp3"></audio> -->
    <div v-if="isOnline">
      <template>
        <notifications />
        <template v-if="user">
          <div :class="{ 'nav-open': $sidebar.showSidebar }">
            <template v-for="(card, key) in $route.query">
              <component
                :key="key"
                :is="key"
                :style="{
                  zIndex: priority[key] ? priority[key] : 10,
                }"
                v-if="items[key]"
                :id="card"
              />
            </template>
            <router-view />
          </div>
          <post-content
            :style="{
              zIndex: priority[items.length] ? priority[key] + 1 : 5,
            }"
            v-if="post"
            :id="post"
          ></post-content>
        </template>
        <div v-else>
          <auth v-if="inital" />
        </div>
      </template>
      <button @click="calc" class="calc" type="button">
        <span class="ti-info"></span>
      </button>
    </div>
    <div v-else>
      <card>
        <h6 class="text-center">Нет Интернета / No Internet / Internet Yo'q</h6>
      </card>
    </div>
  </div>
</template>

<script>
import Auth from "@/pages/Auth";
import { system } from "@/plugins/functions";
import { mapState } from "vuex";

export default {
  data: () => ({
    inital: false,
    audio: null,
    priority: {},
    isCard: false,
    bid: localStorage.getItem("bid"),
  }),
  components: {
    Auth,
  },
  computed: {
    ...mapState(["user", "modalName", "items", "lastMessage", "root", "post"]),
    isOnline: {
      get() {
        if (navigator.onLine) {
          return true;
        } else {
          return false;
        }
      },
    },
  },
  methods: {
    system: system,
    calc() {
      let element = "item_calculator";
      let link = "1";
      let query = Object.assign({}, this.$route.query);
      if (query[element] == link) {
        return false;
      }
      if (query[element]) {
        delete query[element];
      }
      query[element] = link;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  },
  async mounted() {
    await this.$store.dispatch("setAudio", new Audio("/notify.mp3"));
  },
  created() {
    this.system();
  },
  watch: {
    modalName(val) {
      if (val) {
        setTimeout(() => {
          this.$modal.show(val.model);
        }, 10);
      }
    },
    "$route.query": {
      handler: function (val) {
        let k = 1;
        let isOpened = false;
        for (var key in val) {
          if (this.items[key]) {
            isOpened = true;
          }
          k++;
          this.priority[key] = 3 + k;
        }
        if (isOpened === true) {
          document.documentElement.style.overflowY = "hidden";
        } else {
          document.documentElement.style.overflowY = "scroll";
        }
        this.isCard = isOpened;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style>
.notifications {
  z-index: 99999999999999999;
}

.calc {
  padding: 6px 10px 3px 8px;
  position: fixed;
  right: -5px;
  top: -5px;
  border: none;
  box-shadow: none;
  border-radius: 9px;
  z-index: 9999999;
  background: #93ef0f;
  color: #fff;
}
</style>

